// @ts-nocheck -- We currently have the wrong version of @types/react-dom installed.
import { createRoot } from 'react-dom/client';
import App from './AppVite';

createRoot(document.getElementById('root')!).render(<App />);
